import classNames from 'classnames';
import React from 'react';
import styles from './CreateAccountConfirmation.module.scss';
import { LoginBox, Paragraph } from 'ui/components';

export interface CreateAccountConfirmationProps {
	className?: string;
	heading?: string;
	text?: string;
	payByAddress?: {
		companyName?: string;
		address?: string;
		address2?: string;
		postalCode?: string;
		city?: string;
		country?: string;
	};
	invoiceAddress?: {
		companyName?: string;
		address?: string;
		address2?: string;
		postalCode?: string;
		city?: string;
		country?: string;
	};
	serviceInfo?: string | React.ReactNode;
}

export const CreateAccountConfirmation: React.FC<CreateAccountConfirmationProps> = ({
	// className,
	heading,
	text,
	payByAddress,
	invoiceAddress,
	serviceInfo,
}) => {
	return (
		<LoginBox heading={heading}>
			{text && <Paragraph className={classNames('u-bottom-margin--md')}>{text}</Paragraph>}

			<Paragraph className={classNames('u-bottom-margin--md')}>
				<strong>Pay-by address</strong>
				<br />
				{payByAddress?.companyName}
				<br />
				{payByAddress?.address}
				<br />
				{payByAddress?.address2}
				{payByAddress.address2 ? <br /> : ''}
				{payByAddress?.postalCode} {payByAddress?.city}
				<br />
				{payByAddress?.country}
			</Paragraph>
			<Paragraph className={classNames('u-bottom-margin--md')}>
				<strong>Invoice address</strong>
				<br />
				{invoiceAddress?.companyName}
				<br />
				{invoiceAddress?.address}
				<br />
				{invoiceAddress.address2 ? invoiceAddress.address2 && <br /> : null}
				{invoiceAddress?.postalCode} {invoiceAddress?.city}
				<br />
				{invoiceAddress?.country}
			</Paragraph>
			<Paragraph className={classNames(styles.CreateAccountConfirmation_service)}>{serviceInfo}</Paragraph>
		</LoginBox>
	);
};
